import React, { Fragment, useRef } from 'react';
import { Transition, Dialog } from '@headlessui/react';
import { ExclamationTriangleIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import ButtonPrimary from "../buttons/ButtonPrimary";
import ButtonSecondary from "../buttons/ButtonSecondary";

function Speedbump({
  open,
  setOpen,
  onConfirm,
  onClose,
  confirmTitle,
  confirmBody,
  confirmBtnText,
  cancelBtnText="Cancel",
  warning= true
}) {
  const cancelButtonRef = useRef(null);
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[60]"
        initialFocus={cancelButtonRef}
        onClose={onClose ? onClose : () => setOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-30 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="sm:flex sm:items-start">
                  <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full ${warning ? 'bg-red-50' : 'bg-blue-50'} sm:mx-0 sm:h-10 sm:w-10`}>
                   { warning ? <ExclamationTriangleIcon
                      className="h-6 w-6 text-red-400"
                      aria-hidden="true"
                    /> :
                    <QuestionMarkCircleIcon
                      className="h-6 w-6  text-blue-400"
                      aria-hidden="true"
                    />
                    }
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      {confirmTitle}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {confirmBody}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                  <ButtonPrimary
                    type="button"
                    className={warning && "bg-red-600 hover:bg-red-700 focus:ring-red-500"}
                    onClick={onConfirm}
                  >
                    {confirmBtnText}
                  </ButtonPrimary>
                  <ButtonSecondary
                    type="button"
                    onClick={onClose}
                    ref={cancelButtonRef}
                  >
                    {cancelBtnText}
                  </ButtonSecondary>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default Speedbump;
